import { render, staticRenderFns } from "./PopUp.vue?vue&type=template&id=683b9ba4&scoped=true&"
import script from "./PopUp.vue?vue&type=script&lang=ts&"
export * from "./PopUp.vue?vue&type=script&lang=ts&"
import style0 from "./PopUp.vue?vue&type=style&index=0&id=683b9ba4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683b9ba4",
  null
  
)

export default component.exports